import styled from 'styled-components';
import { StyledMenuBarWrapper } from './StyledMenuBarWrapper';
import { StyledRteEditor } from './StyledRteEditor';
import { StyledRteTheme } from './StyledRteTheme';

export const StyledRteContainer = styled.div`
  // applichiamo gli stili all'editor quando è in focus il container
  &:focus-within,
  &:hover {
    ${StyledRteEditor}, ${StyledMenuBarWrapper} {
      border-color: ${props =>
        props.theme.colorPrimaryHover ?? StyledRteTheme.colorPrimaryHover};

      .ant-form-item-has-error & {
        border-color: ${props =>
          props.theme.colorError ?? StyledRteTheme.colorError};
      }
      &.rte-input-disabled {
        border-color: ${props =>
          props.theme.colorBorder ?? StyledRteTheme.colorBorder};
      }
    }
  }

  &:focus-within {
    ${StyledRteEditor}, ${StyledMenuBarWrapper} {
      border-color: ${props =>
        props.theme.colorPrimaryHover ?? StyledRteTheme.colorPrimaryHover};
      outline: none;
    }
  }

  // Per applicare lo shadows a tutto l'elemento dobbiamo impostare il corretto Radius
  // In Antd il border-radius varia in funzione della grandezza degli input
  border-radius: ${props =>
    props.theme.borderRadius ?? StyledRteTheme.borderRadius}px;
  &.rte-container-lg {
    border-radius: ${props =>
      props.theme.borderRadiusLG ?? StyledRteTheme.borderRadiusLG}px;
  }
  &.rte-container-sm {
    border-radius: ${props =>
      props.theme.borderRadiusSM ?? StyledRteTheme.borderRadiusSM}px;
  }

  &:focus-within {
    box-shadow: 0 0 0
      ${props =>
        props.theme.controlOutlineWidth ?? StyledRteTheme.controlOutlineWidth}px
      ${props => props.theme.controlOutline ?? StyledRteTheme.controlOutline};
    outline: none;
    .ant-form-item-has-error & {
      box-shadow: 0 0 0
        ${props =>
          props.theme.controlOutlineWidth ??
          StyledRteTheme.controlOutlineWidth}px
        ${props =>
          props.theme.colorErrorOutline ?? StyledRteTheme.colorErrorOutline};
    }
  }
`;
